import type { FaireReviewEntity } from "../../entity_types/review";

// Real brand-level review from Beefy's Own's live Faire brand page
// (review token br_4vu5yks5da) — verbatim text/name/location, `publish_at`
// date. Purchased-product pairing follows review_bo1's note.
//
// Kept at full length on purpose: it's the longest quote in the brand's pool,
// so it's the stress case for any featured-review layout that has to hold a
// large pull-quote without the card collapsing.
export const review_bo5: FaireReviewEntity = {
  token: "review_bo5",
  type: "review",
  brandName: "Beefy's Own",
  brandToken: "b_d6aqh4qdhb",
  reviewerName: "Dawn",
  reviewerLocation: "Kenosha, WI, United States",
  stars: 5,
  reviewText:
    "These are awesome. Everyone likes that they are chemical free, made with all natural ingredients. So, we have our niche market of no artificial preservatives. Customers have reported once they open the bag it is game over and they eat them all in 1 sitting. Not sure if smaller bags maybe in the future of grab and go size.",
  reviewDate: "Mar 27, 2026",
  reviewType: "brand",
  purchasedProductTokens: [
    "p_xz2fzy3cqc",
    "p_b7tqfj6z9q",
    "p_tuu6txxtve",
    "p_6sy6atfkhp",
  ],
  meta: {
    source: "api",
    importedAt: "2026-08-16T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
